module.exports = __webpack_public_path__ + "media/assets/staffs/tsehau_chao-f44a3f14fbc083a52e4771a18e7d54e8.jpg";